import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Выделенная карточка — например, рекомендованный тариф. */
  highlighted?: boolean;
}

export function Card({ highlighted, className, children, ...props }: CardProps) {
  return (
    <div
      className={cn(
        'surface-card p-5 sm:p-6',
        highlighted && 'border-[var(--accent)] shadow-[var(--shadow-raised)]',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardTitle({ children, className }: { children: ReactNode; className?: string }) {
  return <h3 className={cn('text-lg font-semibold text-[var(--text-primary)]', className)}>{children}</h3>;
}

export function CardSubtitle({ children, className }: { children: ReactNode; className?: string }) {
  return <p className={cn('text-sm text-muted', className)}>{children}</p>;
}
